import type React from 'react';

import { Image } from '@change/ds-core-ui/Image';

type Props = Readonly<{
	id: string;
	url: string;
	mobileUrl: string;
}>;

export const Photo: React.FC<Props> = ({ id, url, mobileUrl }) => {
	return <Image aspectRatio="16:9" id={id} src={url || mobileUrl} alt="" className="w-full align-top" />;
};
